import React from 'react';

// Politique de clôture d'une prestation (2026-10-19, demande d'Emeni) : qui peut commencer / terminer, et quelles photos
// demander, différemment pour un particulier (2-3 salariés qui s'accordent) et pour une entreprise (équipe nombreuse :
// un responsable sur place, des photos d'ensemble plutôt qu'une par chaise). Calculée par le serveur ; réglée dans
// Paramètres > Planning.
export type ModePhotos = 'avant_apres' | 'facultatives' | 'ensemble' | 'ensemble_facultatif' | 'aucune';

export interface CloturePolitique {
    photos_mode: ModePhotos;
    restreint: boolean;
    responsable_id: string | null;
    responsable_nom: string;
    // Nom que l'établissement donne au rôle (« Responsable », « Chef d'équipe », « Manager »…).
    role_label?: string;
    peut_cloturer: boolean;
    type?: string;
}

export const LIBELLES_MODE_PHOTOS: Record<ModePhotos, string> = {
    avant_apres: 'Photo avant et après, obligatoires',
    facultatives: 'Photo avant et après, facultatives',
    ensemble: "Photos d'ensemble (jusqu'à 6), au moins une obligatoire",
    ensemble_facultatif: "Photos d'ensemble (jusqu'à 6), facultatives",
    aucune: 'Aucune photo',
};

export const exigeAvantApres = (m: ModePhotos) => m === 'avant_apres';
export const modeEnsemble = (m: ModePhotos) => m === 'ensemble' || m === 'ensemble_facultatif';
export const avecAvantApres = (m: ModePhotos) => m === 'avant_apres' || m === 'facultatives';

// Photos par type d'article (2026-10-20) : une paire avant/après par article, pour les particuliers comme pour les
// entreprises (un restaurant de 60 chaises et 15 canapés : une paire « Chaises », une paire « Canapés »).
export const avecPaires = (m: ModePhotos) => m !== 'aucune';
export const pairesObligatoires = (m: ModePhotos) => m === 'avant_apres' || m === 'ensemble';

/**
 * Politique d'un rendez-vous. `initiale` : déjà fournie avec le rendez-vous (portail salarié) ; sinon on la demande au serveur.
 * Tant qu'elle n'est pas connue, `politique` est null et l'écran garde son comportement historique (jamais de blocage à tort).
 */
export function useCloturePolitique(appointmentId: string, fetcher: (url: string) => Promise<any>, initiale?: CloturePolitique | null) {
    const [politique, setPolitique] = React.useState<CloturePolitique | null>(initiale || null);
    React.useEffect(() => {
        let annule = false;
        if (initiale) { setPolitique(initiale); return; }
        fetcher(`/prestation-planning/appointments/${appointmentId}/cloture-politique`)
            .then((r: any) => { if (!annule && r && !r.error && r.photos_mode) setPolitique(r as CloturePolitique); })
            .catch(() => {});
        return () => { annule = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);
    return politique;
}
